export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российский размер`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`, `54-56`],
  [`В груди, полуобхват, см`, `58`, `60`, `62`, `64`, `66`, `68`],
  [`Длина, см`, `66`, `68`, `70`, `72`, `74`, `76`],
];
